/* @flow */
import * as React from 'react';
import { observer } from 'mobx-react';
import { translate } from 'react-i18next';

import type { TranslatorProps } from 'react-i18next';

import SiteAddress from 'components/SiteAddress/SiteAddress';
import ActionDrawerFormButtons from 'views/ActionDrawer/components/ActionDrawerFormButtons/ActionDrawerFormButtons';
import ActionDrawerBlock from 'views/ActionDrawer/components/ActionDrawerBlock/ActionDrawerBlock';

import styles from '../../../../ActionDrawer.module.scss';
import { ComponentWithInjectedProps } from 'utils/injectedProps';

type InjectedProps = TranslatorProps;

type DeleteUserLocationFormProps = {
  user: Object,
};

@translate()
@observer
export default class DeleteUserLocationForm extends ComponentWithInjectedProps<
  DeleteUserLocationFormProps,
  {},
  InjectedProps
> {
  render() {
    const { t, user, form } = this.props;

    return (
      <React.Fragment>
        <div className={styles['action-drawer-content']}>
          <ActionDrawerBlock gutters={true} heading={t('general:activities.assigned_location')}>
            <div className={styles['info-block']}>
              <SiteAddress {...user.location.site.address} siteName={this.siteName} />
            </div>
          </ActionDrawerBlock>
        </div>
        <ActionDrawerFormButtons form={form} submitTxt={t('general:actions.remove_location')} />
      </React.Fragment>
    );
  }
}
